import Link from 'next/link';
import { useReduxState } from 'hooks';
import { InfoCountTileContent } from '.';

import type { InfoCountTileContentProps } from './InfoCountTileContent';

type Props = InfoCountTileContentProps &
  (
    | {
        href?: never;
        onClick: () => void;
      }
    | {
        href: string;
        onClick?: never;
      }
  );

const InfoCountTile = ({
  category,
  href,
  icon,
  onClick,
  text,
  value
}: Props) => {
  const { theme } = useReduxState();

  const WrapperElement = ({ children }) =>
    href ? (
      <Link
        href={href}
        style={{
          color: 'inherit',
          cursor: 'pointer',
          textDecoration: 'none'
        }}
      >
        {children}
      </Link>
    ) : (
      <button
        onClick={onClick}
        style={{
          backgroundColor: 'transparent',
          border: 0,
          fontFamily: 'inherit',
          padding: 0,
          width: '100%'
        }}
      >
        {children}
      </button>
    );

  return (
    <WrapperElement>
      <div className="content">
        <InfoCountTileContent
          category={category}
          icon={icon}
          text={text}
          value={value}
        />
      </div>

      <style jsx>{`
        .content {
          background-color: white;
          border-radius: 10px;
          box-shadow: ${theme.cardBoxShadow};
          cursor: pointer;
          padding: 10px 20px;
          transition: box-shadow 0.3s;
        }
        .content:hover {
          box-shadow: ${theme.cardBoxShadowActive};
        }
      `}</style>
    </WrapperElement>
  );
};

export default InfoCountTile;
